// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tile---wQwMT {
  position: relative;
  margin-top: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tile---wQwMT:nth-child(1),
.tile---wQwMT:nth-child(2),
.tile---wQwMT:nth-child(3) {
  margin-top: 0;
}
.tile---wQwMT:nth-child(3n + 1),
.tile---wQwMT:nth-child(3n + 2) {
  margin-right: 26px;
}
.tile---wQwMT a {
  text-decoration: none;
  position: relative;
}
.tile---wQwMT a:visited {
  color: #444;
}
.tile---wQwMT a:hover .imageCover---yBmyG {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon---yOXkt {
  position: absolute;
  top: 8px;
  right: 8px;
}
.image---iUATj {
  width: 295px;
  height: 295px;
  object-fit: cover;
}
.imageCover---yBmyG {
  position: absolute;
  top: 0;
  left: 0;
  width: 295px;
  height: 295px;
  display: none;
  background: rgba(0, 0, 0, 0.3);
  font-size: 17px;
  color: #ffffff;
  letter-spacing: -0.45px;
  line-height: 20px;
}
.imageCover---yBmyG .visitLabel---Xd0Tn {
  margin-left: 5px;
}
.showDisplayText---f9HJA {
  height: 343px;
}
.showDisplayText---f9HJA:nth-child(1),
.showDisplayText---f9HJA:nth-child(2),
.showDisplayText---f9HJA:nth-child(3) {
  margin-top: -22px;
}
.displayText---Heqbx {
  position: absolute;
  max-height: 50px;
  width: 295px;
  text-align: left;
  padding: 5px 1px 5px 1px;
  font-size: 12px;
  line-height: 18px;
  color: #757575;
}
@media (max-width: 767.98px) {
  .tile---wQwMT {
    width: calc(50vw);
    height: calc(50vw - 8px);
    margin-top: 0;
  }
  .tile---wQwMT:nth-child(3n + 1),
  .tile---wQwMT:nth-child(3n + 2) {
    margin: 0;
  }
  .tile---wQwMT .imageWrapper---Eh_Lc {
    position: absolute;
  }
  .tile---wQwMT:nth-child(odd) .imageWrapper---Eh_Lc {
    right: 1px;
  }
  .tile---wQwMT:nth-child(even) .imageWrapper---Eh_Lc {
    left: 1px;
  }
  .image---iUATj,
  .imageCover---yBmyG {
    width: calc(50vw - 10px);
    height: calc(50vw - 10px);
  }
  .displayText---Heqbx {
    width: calc(50vw - 10px);
    max-height: 40px;
  }
  .showDisplayText---f9HJA {
    height: calc(50vw + 61px);
  }
  .showDisplayText---f9HJA:nth-child(1),
  .showDisplayText---f9HJA:nth-child(2) {
    margin-top: -12px;
  }
  .showDisplayText---f9HJA:nth-child(3) {
    margin-top: 0;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .tile---wQwMT {
    width: calc(33vw);
    height: calc(33vw);
    margin-top: 0;
  }
  .tile---wQwMT:nth-child(3n + 1) {
    margin: 0;
  }
  .tile---wQwMT:nth-child(3n + 2) {
    width: calc(34vw);
    margin: 0;
  }
  .tile---wQwMT:nth-child(3n + 3) {
    margin: 0;
  }
  .tile---wQwMT .imageWrapper---Eh_Lc {
    position: absolute;
  }
  .tile---wQwMT:nth-child(3n + 1) .imageWrapper---Eh_Lc {
    right: 0;
  }
  .tile---wQwMT:nth-child(3n + 2) .imageWrapper---Eh_Lc {
    position: relative;
  }
  .tile---wQwMT:nth-child(3n + 3) .imageWrapper---Eh_Lc {
    left: 0;
  }
  .image---iUATj,
  .imageCover---yBmyG {
    width: calc(33vw - 10px);
    height: calc(33vw - 10px);
  }
  .displayText---Heqbx {
    width: calc(33vw - 10px);
    max-height: 40px;
  }
  .showDisplayText---f9HJA {
    height: calc(33vw + 62px);
  }
  .showDisplayText---f9HJA:nth-child(1),
  .showDisplayText---f9HJA:nth-child(2),
  .showDisplayText---f9HJA:nth-child(3) {
    margin-top: -12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/default_tile.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EAaA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;AAZF;AAHE;;;EAGE,aAAA;AAKJ;AAFE;;EAEE,kBAAA;AAIJ;AAhBA;EAsBI,qBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AASA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAPF;AAUA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AARF;AAWA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EAEA,aAAA;EAEA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAXF;AAFA;EAgBI,gBAAA;AAXJ;AAeA;EACE,aAAA;AAbF;AAeE;;;EAGE,iBAAA;AAbJ;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfF;AAmBA;EACE;IACE,iBAAA;IACA,wBAAA;IACA,aAAA;EAjBF;EAmBE;;IAEE,SAAA;EAjBJ;EAUA;IAWI,kBAAA;EAlBJ;EAqBE;IACE,UAAA;EAnBJ;EAsBE;IACE,SAAA;EApBJ;EAwBA;;IAEE,wBAAA;IACA,yBAAA;EAtBF;EAyBA;IACE,wBAAA;IACA,gBAAA;EAvBF;EA0BA;IACE,yBAAA;EAxBF;EA0BE;;IAEE,iBAAA;EAxBJ;EA2BE;IACE,aAAA;EAzBJ;AACF;AA8BA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,aAAA;EA5BF;EA8BE;IACE,SAAA;EA5BJ;EA+BE;IACE,iBAAA;IACA,SAAA;EA7BJ;EAgCE;IACE,SAAA;EA9BJ;EAeA;IAmBI,kBAAA;EA/BJ;EAkCE;IACE,QAAA;EAhCJ;EAmCE;IACE,kBAAA;EAjCJ;EAoCE;IACE,OAAA;EAlCJ;EAsCA;;IAEE,wBAAA;IACA,yBAAA;EApCF;EAuCA;IACE,wBAAA;IACA,gBAAA;EArCF;EAwCA;IACE,yBAAA;EAtCF;EAwCE;;;IAGE,iBAAA;EAtCJ;AACF","sourcesContent":[".tile {\n  position: relative;\n  margin-top: 26px;\n\n  &:nth-child(1),\n  &:nth-child(2),\n  &:nth-child(3) {\n    margin-top: 0;\n  }\n\n  &:nth-child(3n + 1),\n  &:nth-child(3n + 2) {\n    margin-right: 26px;\n  }\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n\n  a {\n    text-decoration: none;\n    position: relative;\n\n    &:visited {\n      color: #444;\n    }\n\n    &:hover .imageCover {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n\n.image {\n  width: 295px;\n  height: 295px;\n  object-fit: cover;\n}\n\n.imageCover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 295px;\n  height: 295px;\n\n  display: none;\n\n  background: rgba(0, 0, 0, 0.3);\n  font-size: 17px;\n  color: #ffffff;\n  letter-spacing: -0.45px;\n  line-height: 20px;\n\n  .visitLabel {\n    margin-left: 5px;\n  }\n}\n\n.showDisplayText {\n  height: 343px;\n\n  &:nth-child(1),\n  &:nth-child(2),\n  &:nth-child(3) {\n    margin-top: -22px;\n  }\n}\n\n.displayText {\n  position: absolute;\n  max-height: 50px;\n  width: 295px;\n  text-align: left;\n  padding: 5px 1px 5px 1px;\n  font-size: 12px;\n  line-height: 18px;\n  color: #757575;\n}\n\n// Small devices (landscape phones, less than 768px)\n@media (max-width: 767.98px) {\n  .tile {\n    width: calc(50vw);\n    height: calc(50vw - 8px);\n    margin-top: 0;\n\n    &:nth-child(3n + 1),\n    &:nth-child(3n + 2) {\n      margin: 0;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(50vw - 10px);\n    height: calc(50vw - 10px);\n  }\n\n  .displayText {\n    width: calc(50vw - 10px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc(50vw + 61px);\n\n    &:nth-child(1),\n    &:nth-child(2) {\n      margin-top: -12px;\n    }\n\n    &:nth-child(3) {\n      margin-top: 0;\n    }\n  }\n}\n\n// Medium devices (tablets, less than 992px)\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .tile {\n    width: calc(33vw);\n    height: calc(33vw);\n    margin-top: 0;\n\n    &:nth-child(3n + 1) {\n      margin: 0;\n    }\n\n    &:nth-child(3n + 2) {\n      width: calc(34vw);\n      margin: 0;\n    }\n\n    &:nth-child(3n + 3) {\n      margin: 0;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(3n + 1) .imageWrapper {\n      right: 0;\n    }\n\n    &:nth-child(3n + 2) .imageWrapper {\n      position: relative;\n    }\n\n    &:nth-child(3n + 3) .imageWrapper {\n      left: 0;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(33vw - 10px);\n    height: calc(33vw - 10px);\n  }\n\n  .displayText {\n    width: calc(33vw - 10px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc(33vw + 62px);\n\n    &:nth-child(1),\n    &:nth-child(2),\n    &:nth-child(3) {\n      margin-top: -12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `tile---wQwMT`,
	"imageCover": `imageCover---yBmyG`,
	"icon": `icon---yOXkt`,
	"image": `image---iUATj`,
	"visitLabel": `visitLabel---Xd0Tn`,
	"showDisplayText": `showDisplayText---f9HJA`,
	"displayText": `displayText---Heqbx`,
	"imageWrapper": `imageWrapper---Eh_Lc`
};
export default ___CSS_LOADER_EXPORT___;
